import { render, staticRenderFns } from "./SettingsForm.vue?vue&type=template&id=fbf2c2d2&scoped=true&lang=html"
import script from "./SettingsForm.vue?vue&type=script&lang=js"
export * from "./SettingsForm.vue?vue&type=script&lang=js"
import style0 from "./SettingsForm.vue?vue&type=style&index=0&id=fbf2c2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf2c2d2",
  null
  
)

export default component.exports